import React from 'react'

import Dialog, { DialogProps } from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button/Button'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import SaveIcon from '@mui/icons-material/Save'
import { GroupViewDTO } from 'src/types/group/groupData'
import GroupForm from "../../../../grupos/GroupForm";

interface UserFormDialogProps extends DialogProps {
    group?: GroupViewDTO
    onClose: () => void
    onAfterSubmit: () => void
    onSubmitError: (errorMessage: string) => void
}

function GroupFormDialog({ group, onClose, onAfterSubmit, onSubmitError, ...dialogProps }: UserFormDialogProps) {
    return (
        <Dialog {...dialogProps}>
            <DialogTitle>{group ? 'Modificación de grupo' : 'Alta de grupo'}</DialogTitle>
            <DialogContent>
                <GroupForm
                    group={group}
                    onAfterSubmit={() => {
                        onAfterSubmit()
                        onClose()
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant='outlined'
                    color='primary'
                    size='medium'
                    startIcon={<CloseRoundedIcon />}
                    onClick={onClose}
                >
                    Cancelar
                </Button>
                <Button
                    variant='contained'
                    color='primary'
                    size='medium'
                    type='submit'
                    form={'group-form'}
                    startIcon={<SaveIcon />}
                >
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default GroupFormDialog
